import React, { useEffect, useState, useRef } from "react";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { Chart, registerables } from "chart.js";

export default function Try() {
    const [sortDirection, setSortDirection] = useState("asc");
    const [isSorting, setIsSorting] = useState(false);

    const filterInputRef = useRef(null);
    const downloadTableRef = useRef(null);
    const downloadPDFRef = useRef(null);
    const sortBtnRef = useRef(null);
    const passedBtnRef = useRef(null);
    const failedBtnRef = useRef(null);
    const resetBtnRef = useRef(null);

    useEffect(() => {
        Chart.register(...registerables);

        const updatestat = () => {
            const canvas = document.getElementById("myChart");
            if (!canvas) return;

            let chartStatus = Chart.getChart("myChart");
            if (chartStatus) chartStatus.destroy();

            const ctx = canvas.getContext("2d");
            const table = document.getElementById("myTable");
            if (!table) return;

            const rows = Array.from(table.getElementsByTagName("tr")).slice(1);
            let totalStudents = 0;
            let passedCount = 0;
            let failedCount = 0;
            let totalMarks = 0;
            let maxMarks = -Infinity;
            let minMarks = Infinity;

            rows.forEach(row => {
                if (row.classList.contains('hidden') || row.style.display === 'none') return;

                const cells = row.getElementsByTagName("td");
                const finalGrade = Number(cells[6].textContent);
                const status = cells[7].textContent;

                totalStudents++;
                totalMarks += finalGrade;
                maxMarks = Math.max(maxMarks, finalGrade);
                minMarks = Math.min(minMarks, finalGrade);

                if (status === "Passed") passedCount++;
                else if (status === "Failed") failedCount++;
            });

            const totalStudentsDiv = document.getElementById("total-students");
            if (totalStudentsDiv) totalStudentsDiv.textContent = totalStudents;

            const averageMarks = totalStudents > 0 ? (totalMarks / totalStudents).toFixed(2) : 0;
            const statsUl = document.querySelector("#statscontent ul");
            if (statsUl) {
                statsUl.innerHTML = "";
                const labels = ["Passed", "Failed", "Average Marks", "Max Marks", "Min Marks"];
                const dataValues = [passedCount, failedCount, averageMarks, maxMarks === -Infinity ? 0 : maxMarks, minMarks === Infinity ? 0 : minMarks];

                labels.forEach((label, i) => {
                    const li = document.createElement("li");
                    li.innerHTML = `<span>${label}: </span><span>${dataValues[i]}</span>`;
                    statsUl.appendChild(li);
                });
            }

            new Chart(ctx, {
                type: "radar",
                data: {
                    labels: ["Passed", "Failed", "Average Marks", "Max Marks", "Min Marks"],
                    datasets: [{
                        label: "Statistics",
                        data: [passedCount, failedCount, averageMarks, maxMarks === -Infinity ? 0 : maxMarks, minMarks === Infinity ? 0 : minMarks],
                        backgroundColor: "rgba(0, 255, 0, 0.5)"
                    }]
                },
                options: { maintainAspectRatio: false, responsive: false }
            });

            // Pie Chart
            const pieCanvas = document.getElementById("pie");
            if (pieCanvas) {
                let pieStatus = Chart.getChart("pie");
                if (pieStatus) pieStatus.destroy();

                let ranges = [0, 0, 0, 0, 0]; // 0-2, 2-4, 4-6, 6-8, 8-10
                rows.forEach(row => {
                    if (row.classList.contains('hidden') || row.style.display === 'none') return;
                    const grade = Number(row.getElementsByTagName("td")[6].textContent);
                    if (grade < 2) ranges[0]++;
                    else if (grade < 4) ranges[1]++;
                    else if (grade < 6) ranges[2]++;
                    else if (grade < 8) ranges[3]++;
                    else ranges[4]++;
                });

                new Chart(pieCanvas.getContext("2d"), {
                    type: "doughnut",
                    data: {
                        labels: ["0-2", "2-4", "4-6", "6-8", "8-10"],
                        datasets: [{
                            data: ranges,
                            backgroundColor: ["green", "yellowgreen", "yellow", "orange", "red"]
                        }]
                    },
                    options: { maintainAspectRatio: false, responsive: false }
                });
            }

            // Bar Chart (Line)
            const lineCanvas = document.getElementById("line");
            if (lineCanvas) {
                let lineStatus = Chart.getChart("line");
                if (lineStatus) lineStatus.destroy();

                const topics = {};
                rows.forEach(row => {
                    const topic = row.getElementsByTagName("td")[3].textContent;
                    const passed = row.getElementsByTagName("td")[7].textContent === "Passed";
                    if (!topics[topic]) topics[topic] = { passed: 0, failed: 0 };
                    if (passed) topics[topic].passed++;
                    else topics[topic].failed++;
                });

                new Chart(lineCanvas.getContext("2d"), {
                    type: "bar",
                    data: {
                        labels: Object.keys(topics),
                        datasets: [
                            { label: "Passed", data: Object.values(topics).map(t => t.passed), backgroundColor: "green" },
                            { label: "Failed", data: Object.values(topics).map(t => t.failed), backgroundColor: "red" }
                        ]
                    },
                    options: { maintainAspectRatio: false, responsive: false, scales: { x: { stacked: true }, y: { stacked: true } } }
                });
            }
        };

        const sortTableByName = () => {
            const table = document.getElementById("myTable");
            if (!table) return;
            const tbody = table.querySelector("tbody");
            const rows = Array.from(tbody.querySelectorAll("tr"));

            rows.sort((a, b) => {
                const nameA = a.children[1].textContent.toUpperCase();
                const nameB = b.children[1].textContent.toUpperCase();
                return sortDirection === "asc" ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
            });

            rows.forEach(row => tbody.appendChild(row));
            setSortDirection(prev => prev === "asc" ? "desc" : "asc");

            const header = document.getElementById("name-header");
            if (header) header.innerHTML = `Name ${sortDirection === "asc" ? "&#8595;" : "&#8593;"}`;
        };

        const resetTable = () => {
            const table = document.getElementById("myTable");
            if (!table) return;
            const rows = Array.from(table.querySelectorAll("tbody tr"));
            rows.forEach(row => {
                row.classList.remove("hidden");
                row.style.display = "";
            });
            rows.sort((a, b) => Number(a.children[0].textContent) - Number(b.children[0].textContent));
            rows.forEach(row => table.querySelector("tbody").appendChild(row));
            updatestat();
        };

        const filterTable = (e) => {
            const val = e.target.value.toUpperCase();
            const table = document.getElementById("myTable");
            if (!table) return;
            const rows = table.querySelectorAll("tbody tr");
            rows.forEach(row => {
                const name = row.children[1].textContent.toUpperCase();
                row.style.display = name.includes(val) ? "" : "none";
            });
        };

        const filterByStatus = (status) => {
            const table = document.getElementById("myTable");
            if (!table) return;
            const rows = table.querySelectorAll("tbody tr");
            rows.forEach(row => {
                const rowStatus = row.children[7].textContent;
                row.style.display = rowStatus === status ? "" : "none";
            });
            updatestat();
        };

        const downloadCSV = () => {
            const table = document.getElementById("myTable");
            if (!table) return;
            let csv = "";
            const rows = table.querySelectorAll("tr");
            rows.forEach(row => {
                const cols = Array.from(row.querySelectorAll("th, td")).map(c => c.textContent);
                csv += cols.join(",") + "\n";
            });
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.setAttribute("hidden", "");
            a.setAttribute("href", url);
            a.setAttribute("download", "table.csv");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        };

        const downloadPDF = () => {
            const doc = new jsPDF();
            doc.autoTable({ html: '#myTable' });
            doc.save('table.pdf');
        };

        // Attach listeners
        const filters = filterInputRef.current;
        if (filters) filters.onkeyup = filterTable;

        const csvBtn = downloadTableRef.current;
        if (csvBtn) csvBtn.onclick = downloadCSV;

        const pdfBtn = downloadPDFRef.current;
        if (pdfBtn) pdfBtn.onclick = downloadPDF;

        const sortBtn = sortBtnRef.current;
        if (sortBtn) sortBtn.onclick = sortTableByName;

        const passedBtn = passedBtnRef.current;
        if (passedBtn) passedBtn.onclick = () => filterByStatus("Passed");

        const failedBtn = failedBtnRef.current;
        if (failedBtn) failedBtn.onclick = () => filterByStatus("Failed");

        const resetBtn = resetBtnRef.current;
        if (resetBtn) resetBtn.onclick = resetTable;

        // Header listeners (they are in Mainblock)
        const nameHeader = document.getElementById("name-header");
        if (nameHeader) nameHeader.onclick = sortTableByName;

        const statsBtn = document.getElementById("stats");
        if (statsBtn) {
            statsBtn.onclick = () => {
                const statsDiv = document.getElementById("statistics");
                if (statsDiv) statsDiv.classList.remove("hidden");
                updatestat();
            };
        }

        const hideStatsBtn = document.getElementById("hidestats");
        if (hideStatsBtn) {
            hideStatsBtn.onclick = () => {
                const statsDiv = document.getElementById("statistics");
                if (statsDiv) statsDiv.classList.add("hidden");
            };
        }



    }, [sortDirection]);

    return (
        <>
            <input type="text" id="filterInput" ref={filterInputRef} placeholder="Type to filter..." />
            <button id="downloadTable" ref={downloadTableRef}>Download as CSV</button>
            <button id="downloadPDF" ref={downloadPDFRef}>Download as PDF</button>
            <button id="sort" ref={sortBtnRef}> Sort by Name</button>
            <button id="passed-btn" ref={passedBtnRef}>Passed</button>
            <button id="failed-btn" ref={failedBtnRef}>Failed</button>
            <button id="reset-btn" ref={resetBtnRef}>Reset</button>
        </>
    );
}

